<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">
                Добавить расписание
            </div>
        </div>
    </div>

    <div class="inform col-md-4 col-12">
        <div class="title-section">
            <span>Понедельник</span>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="mon_all" v-model="mon_all">
            <label class="form-check-label" for="mon_all">
                Целый день
            </label>
        </div>

        <div class="form-row" v-if="!mon_all">
            <div class="col-md-6">
                <label for="n-display_at" class="form-label">Время начала</label>
                <input class="form-control" id="n-display_at" type="time" v-model="formData.mon_start">
                <div class="valid-feedback">
                    Успешно
                </div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Время окончания</label>
                <input class="form-control" id="n-hide_at" type="time" v-model="formData.mon_end">
                <div class="valid-feedback">
                    Ошибка
                </div>
            </div>
        </div>


        <div class="title-section">
            <span>Вторник</span>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="tue_all" v-model="tue_all">
            <label class="form-check-label" for="tue_all">
                Целый день
            </label>
        </div>

        <div class="form-row" v-if="!tue_all">
            <div class="col-md-6">
                <label for="n-display_at" class="form-label">Время начала</label>
                <input class="form-control" id="n-display_at" type="time" v-model="formData.tue_start">
                <div class="valid-feedback">
                    Успешно
                </div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Время окончания</label>
                <input class="form-control" id="n-hide_at" type="time" v-model="formData.tue_end">
                <div class="valid-feedback">
                    Ошибка
                </div>
            </div>
        </div>



        <div class="title-section">
            <span>Среда</span>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="wed_all" v-model="wed_all">
            <label class="form-check-label" for="wed_all">
                Целый день
            </label>
        </div>

        <div class="form-row" v-if="!wed_all">
            <div class="col-md-6">
                <label for="n-display_at" class="form-label">Время начала</label>
                <input class="form-control" id="n-display_at" type="time" v-model="formData.wed_start">
                <div class="valid-feedback">
                    Успешно
                </div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Время окончания</label>
                <input class="form-control" id="n-hide_at" type="time" v-model="formData.wed_end">
                <div class="valid-feedback">
                    Ошибка
                </div>
            </div>
        </div>



        <div class="title-section">
            <span>Четверг</span>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="thu_all" v-model="thu_all">
            <label class="form-check-label" for="thu_all">
                Целый день
            </label>
        </div>

        <div class="form-row" v-if="!thu_all">
            <div class="col-md-6">
                <label for="n-display_at" class="form-label">Время начала</label>
                <input class="form-control" id="n-display_at" type="time" v-model="formData.thu_start">
                <div class="valid-feedback">
                    Успешно
                </div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Время окончания</label>
                <input class="form-control" id="n-hide_at" type="time" v-model="formData.thu_end">
                <div class="valid-feedback">
                    Ошибка
                </div>
            </div>
        </div>



        <div class="title-section">
            <span>Пятница</span>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="fri_all" v-model="fri_all">
            <label class="form-check-label" for="fri_all">
                Целый день
            </label>
        </div>

        <div class="form-row" v-if="!fri_all">
            <div class="col-md-6">
                <label for="n-display_at" class="form-label">Время начала</label>
                <input class="form-control" id="n-display_at" type="time" v-model="formData.fri_start">
                <div class="valid-feedback">
                    Успешно
                </div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Время окончания</label>
                <input class="form-control" id="n-hide_at" type="time" v-model="formData.fri_end">
                <div class="valid-feedback">
                    Ошибка
                </div>
            </div>
        </div>



        <div class="title-section">
            <span>Суббота</span>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="sat_all" v-model="sat_all">
            <label class="form-check-label" for="sat_all">
                Целый день
            </label>
        </div>

        <div class="form-row" v-if="!sat_all">
            <div class="col-md-6">
                <label for="n-display_at" class="form-label">Время начала</label>
                <input class="form-control" id="n-display_at" type="time" v-model="formData.sat_start">
                <div class="valid-feedback">
                    Успешно
                </div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Время окончания</label>
                <input class="form-control" id="n-hide_at" type="time" v-model="formData.sat_end">
                <div class="valid-feedback">
                    Ошибка
                </div>
            </div>
        </div>



        <div class="title-section">
            <span>Воскресенье</span>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="sun_all" v-model="sun_all">
            <label class="form-check-label" for="sun_all">
                Целый день
            </label>
        </div>

        <div class="form-row" v-if="!sun_all">
            <div class="col-md-6">
                <label for="n-display_at" class="form-label">Время начала</label>
                <input class="form-control" id="n-display_at" type="time" v-model="formData.sun_start">
                <div class="valid-feedback">
                    Успешно
                </div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Время окончания</label>
                <input class="form-control" id="n-hide_at" type="time" v-model="formData.sun_end">
                <div class="valid-feedback">
                    Ошибка
                </div>
            </div>
        </div>


    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <button class="btn btn-lg btn-primary me-3" v-on:click="createWorktime()">
            Добавить
        </button>

        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>
</template>

<script>

import Worktime from "../../../../models/Worktime";

export default {
    name: "WorktimeCreateComponent",
    props: {
        route_back: String,
        route_create: String
    },
    data: function () {
       return {
           worktime: new Worktime({
               route_create: this.route_create
           }),
           clients: [],
           formData: {
               mon_start: 0,
               mon_end: 0,
               tue_start: 0,
               tue_end: 0,
               wed_start: 0,
               wed_end: 0,
               thu_start: 0,
               thu_end: 0,
               fri_start: 0,
               fri_end: 0,
               sat_start: 0,
               sat_end: 0,
               sun_start: 0,
               sun_end: 0
           },
           mon_all: false,
           tue_all: false,
           wed_all: false,
           thu_all: false,
           fri_all: false,
           sat_all: false,
           sun_all: false,
       }
    },
    watch: {
        mon_all: function () {
            if(this.mon_all)
            {
                this.formData.mon_end = 0;
                this.formData.mon_start = 0;
            }
        },
        tue_all: function () {
            if(this.tue_all)
            {
                this.formData.tue_end = 0;
                this.formData.tue_start = 0;
            }
        },
        wed_all: function () {
            if(this.wed_all)
            {
                this.formData.wed_end = 0;
                this.formData.wed_start = 0;
            }
        },
        thu_all: function () {
            if(this.thu_all)
            {
                this.formData.thu_end = 0;
                this.formData.thu_start = 0;
            }
        },
        fri_all: function () {
            if(this.fri_all)
            {
                this.formData.fri_end = 0;
                this.formData.fri_start = 0;
            }
        },
        sat_all: function () {
            if(this.sat_all)
            {
                this.formData.sat_end = 0;
                this.formData.sat_start = 0;
            }
        },
        sun_all: function () {
            if(this.sun_all)
            {
                this.formData.sun_end = 0;
                this.formData.sun_start = 0;
            }
        },
    },
    methods: {
        createWorktime: async function () {
            let result = await this.worktime.create(this.formData);
            if(result)
            {
                window.location.href = this.route_back;
            }
            else
            {
                console.log('error: create_worktime');
            }
        }
    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
